module.exports = __webpack_public_path__ + "img/logosantamaria.7ed87560.svg";